import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";


import { FiArrowRight } from "react-icons/fi";
import exchangeImg from "../../../assets/v3/images/exchange-img.png";
import banner from '../../../assets/v3/images/home-banner-image.png';
import Qr from '../../../assets/images/Qr.png';
import rarrowImg from "../../../assets/v3/images/arrow-right.svg";
import serviceImg1 from "../../../assets/v3/images/service-card-img-1.svg";
import serviceImg2 from "../../../assets/v3/images/service-card-img-2.svg";
import serviceImg3 from "../../../assets/v3/images/service-card-img-3.svg";
import serviceImg4 from "../../../assets/v3/images/service-card-img-4.svg";
import appstoreIcon from "../../../assets/v3/images/Appstore-icon.svg";
import apkIcon from "../../../assets/v3/images/apk-icon.svg";
import playstoreIcon from "../../../assets/v3/images/playstore-icon.svg";
// import telegram from "../../../assets/v3/images/telegram.svg";
import instagram from "../../../assets/v3/images/kucoin.svg";
import twitter from "../../../assets/v3/images/twitter.svg";
import linkedin from "../../../assets/v3/images/linkedin.svg";
import telegram from "../../../assets/v3/images/telegram-logo.svg";
import { FaInstagram,FaWhatsapp,    } from "react-icons/fa";

import NavbarOne from "../NavbarOne";
import Footer from "../Footer";

import { useContextData } from "../../../core/context/index";

import HomeAnnouncement from "./HomeAnnouncement";
import HomeSlider from "./HomeSlider";
import HomeMarket from "./HomeMarket";
import Popup from "./Popup";

import Config from "../../../core/config/";

import {getHomeCMS}  from '../../../core/services/all.api';

// import $ from "jquery";

const exploreData = [
  {
    id: 1,
    title: "Complete the registration",
    description:
      "Register an account to get a crypto mystery box lottery opportunity worth up to 1,000 USDT with a 100% winning rate.",
    imgSrc: rarrowImg,
    link: "/register",
  },
  {
    id: 2,
    title: "Complete the deposit",
    description:
      "Copy Address, Initiate Deposit, Network Confirmation, and Deposit Successful ensuring a seamless and secure transaction.",
    imgSrc: rarrowImg,
    link: "/deposit/crypto",
  },
  {
    id: 3,
    title: "Complete the trade",
    description:
      "Select Trading Pair, Place Order, Order Execution, and Trade Successful ensuring a smooth and efficient trading experience",
    imgSrc: rarrowImg,
    link: "/markets",
  },
  {
    id: 4,
    title: "Secure Platform",
    description:
      "Feel secured with our Extra Shielded Security Solutions.",
    imgSrc: rarrowImg,
    link: "/terms",
  },
  {
    id: 5,
    title: "24/7 Support",
    description:
      "Any kind of Problem. Get it resolved with our 24/7.",
    imgSrc: rarrowImg,
    link: "mailto:support@coindh.com",
  },
  {
    id: 6,
    title: "Discount Trading",
    description:
      "Coin DH enables buying or selling cryptos in real time, 24/7 with only a max 0.5% fee in pair whichever is less",
    imgSrc: rarrowImg,
    link: "/spot/BDX_INR",
  },
];

const services = [
  {
    title: "Low Fees and High Profits",
    description:
      "Our industry-leading encryption and storage systems ensure that your assets are always safe and secure.",
    imgSrc: serviceImg1,
  },
  {
    title: "Strong Account Security",
    description:
      "We adhere to the highest security standards and implement the strictest security practices to keep your account secure.",
    imgSrc: serviceImg2,
  },
  {
    title: "Trusted Platform",
    description:
      "We have a secure-by-design foundation in place to ensure rapid detection and response to any cyber attacks.",
    imgSrc: serviceImg3,
  },
  {
    title: "PoR — Asset Transparency",
    description:
      "PoR verifies asset custody on-chain, proving coinDH holds funds covering all user assets in its records.",
    imgSrc: serviceImg4,
  },
];

const accordionData = [
  {
    id: "collapseTwo",
    question: "What is Crypto Currency?",
    answer:
      "Cryptocurrency is a digital or virtual currency secured by cryptography, making it decentralized and resistant to fraud. Unlike traditional currencies, cryptocurrencies operate on blockchain technology, enabling peer-to-peer transactions without intermediaries like banks.",
  },
  {
    id: "collapseThree",
    question: "Can I start investment with 100₹ ?",
    answer:
      "CoinDH offers a variety of trading and investment options that allow you to buy and sell crypto with as little as ₹100. With products like zero-fee conversion, and spot trading, you can try out different strategies and build your skills on CoinDH without worrying about entry costs",
  },
  {
    id: "collapseFour",
    question: "Can we withdraw profits instantly?",
    answer:
      "Yes! With CoinDH, you can withdraw your profits instantly. Our seamless withdrawal process ensures quick access to your funds with just a few clicks, so you can manage your earnings effortlessly",
  },
  {
    id: "collapseFive",
    question: "Is my money safe on CoinDH?",
    answer:
      "Yes! Your money is safe on CoinDH with advanced security measures like multi-layer encryption, cold wallet storage, two-factor authentication (2FA), and real-time monitoring to protect your funds and data.",
  },
  {
    id: "collapseSix",
    question: "Are there any fees for deposits and withdrawals?",
    answer:
      "Yes, CoinDH offers zero fees on deposits, while withdrawal fees vary depending on the cryptocurrency and network conditions. You can check the latest fee structure on the CoinDH platform before making a transaction.",
  },
];

export default function Home(props) {
  const navigate = useNavigate();

  const { siteSettings, myProfile, setUserProfile } = useContextData();

  const [cmsData, setCmsData] = useState({});

  useEffect(() => {
    getHomeCMSCall();
  }, []);

  const getHomeCMSCall = async () => {
    const resp = await getHomeCMS({ payload: { from: "home" } });
    if(resp) {
      setCmsData(resp);
      const { getcmsDetails = [], status = false } = resp;
      if(status) {
        const adBanner = getcmsDetails.filter(
          (elem) => elem.identify == "adBanner" && elem.image != ""
        );
        const updateCmdData = {
          adBanner: adBanner && adBanner.length > 0 ? adBanner : [],
        };
        setCmsData(updateCmdData);
      }
    }
  }

  // useEffect(() => {
  //   if (window.location.pathname === "/") {
  //     $("body").css("background-color", "#001236");
  //   }
  // }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const isValidHttpUrl = async (val = "") => {
    let url;
    try {
      url = new URL(val);
    } catch (_) {
      return false;
    }
    return url.protocol === "http:" || url.protocol === "https:" || val.startsWith("mailto:");
  }

  const navigateTo = async (link) => {
    if(link) {
      if(await isValidHttpUrl(link)) {
        window.open(link);
      } else {
        navigate(link, true);
      }
    }
  }

  return (
    <div>
      <NavbarOne
        setTheme={props.setTheme}
        theme={props.theme}
        identify={props.identify}
        pageName={"Faq"}
      />
      <Popup />
      <div className="home">
        <section className="home-banner">
          <div className="row h-100 align-items-start">
            <div className="col-lg-6">
              <div className="home-banner-content">
                <div className="home-banner-content-1">
                  <h1 className="h-text-1">
                    Your <span>Crypto</span>, Your <span>Control</span>
                    {/* Safe <span>Trading</span>, Consistent <span>Gains</span> */}
                  </h1>
                  <p className="text-1">We are registered with the <span>Financial Intelligence Unit (FIU)</span> under Indian government regulations</p>
                  {/* <p className="text-1">We are <span>FIU registered</span> with indian regulations</p> */}
                  <p className="p-text-1">
                  COIN DH – A reliable, secure, and low-fee trading platform. Experience seamless trading with top-notch security. Trade smarter and maximize your earnings!
                  </p>
                  <button
                    className="exchange-btn"
                    onClick={() => navigate("/markets")}
                  >
                    View Exchange
                  </button>
                </div>
                <div className="home-banner-content-2">
                  <div className="custom-row">
                    <div className="home-banner-content-2-text">
                      <h2 className="h-text-2">170+</h2>
                      <span className="s-text-1">Countries Covered</span>
                    </div>
                    <div className="home-banner-content-2-text">
                      <h2 className="h-text-2">30 Million</h2>
                      <span className="s-text-1">Global Investors</span>
                    </div>
                  </div>
                  <div className="custom-row">
                    <div className="home-banner-content-2-text">
                      <h2 className="h-text-2">200+</h2>
                      <span className="s-text-1">Coins</span>
                    </div>
                    <div className="home-banner-content-2-text">
                      <h2 className="h-text-2">$1.62 Million</h2>
                      <span className="s-text-1">24h Trading Volume</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 d-none d-lg-block">
              {/* <div className="home-banner-image tab-hide mobile-hide" /> */}
              <img src={banner} className="img-fluid"/>
            </div>
          </div>
        </section>
        <HomeSlider adBannerData={cmsData && cmsData.adBanner ? cmsData.adBanner : []} />
        <HomeMarket />
        <section className="home-section-2">
          <div className="row w-100 h-100">
            <div className="col-lg-7">
              <div className="exchange-div-left">
                <div className="exchange-div-left-text">
                  <h2 className="h-text-2">Try Our Crypto Exchange Now</h2>
                  <p className="p-text-6">
                    Start trading to get up to 1000 USDT in rewards!
                  </p>
                </div>
                <div className="signup-div">
                  <span className="s-text-6">Trade Now</span>
                  <div className="signup-div-body">
                    <p className="p-text-7">
                      Instantly receive 25 USDT tokens + 100 USDT coupons +
                      1000 USDT Futures trial funds, and you will be a winner
                      from the beginning!
                    </p>
                    {myProfile ? (
                      <button className="signup-btn">
                        Trade Now{" "}
                        <FiArrowRight onClick={() => navigate("/markets")} />
                      </button>
                    ) : (
                      <button className="signup-btn">
                        Sign Up{" "}
                        <FiArrowRight
                          onClick={() => navigate("/register")}
                        />
                      </button>
                    )}
                    <small className="tc-text">*Terms and Condition Applied</small>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-5 mobile-hide tab-hide">
              <div className="exchange-div-right">
                <img
                  src={exchangeImg}
                  width={412}
                  height={412}
                  alt="Exchange_Image"
                />
              </div>
            </div>
          </div>
        </section>
        <section className="home-section-3">
          <div className="home-section-3-text">
            <h2 className="h-text-2">Explore CoinDH Products & Services</h2>
            <p className="p-text-10">
              Start trading to get up to 10,800 USDT in rewards!
            </p>
          </div>
          <div className="home-section-3-content">
            <div className="row g-5 w-100 h-100">
              {exploreData.map((card) => (
                <div key={card.id} className="col-md-6 col-lg-4">
                  <div className="explore-card">
                    <div className="explore-card-head">
                      <p className="p-text-8">{card.title}</p>
                      &nbsp;&nbsp;
                      <button className="open-btn" onClick={() => navigateTo(card.link ? card.link : "#")}>
                        <img
                          src={card.imgSrc}
                          width={20}
                          height={20}
                          alt="Arrow_Right_Image"
                        />
                      </button>
                    </div>
                    <div className="explore-card-body">
                      <p className="p-text-9">{card.description}</p>
                    </div>
                    {/* <div className="explore-card-foot mt-auto">
                      <button className="open-btn" onClick={() => navigateTo(card.link ? card.link : "#")}>
                        <img
                          src={card.imgSrc}
                          width={20}
                          height={20}
                          alt="Arrow_Right_Image"
                        />
                      </button>
                    </div>
                    <div className="explore-card-img-wrapper">
                      <div className="explore-card-img" />
                    </div> */}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
        <section className="home-section-3">
          <div className="home-section-3-text">
            <h2 className="h-text-2">Explore CoinDH Products & Services</h2>
            <p className="p-text-10">
              Start trading to get up to 10,800 USDT in rewards!
            </p>
          </div>
          <div className="home-section-3-grid">
            <div className="row g-5">
              {services.map((service, index) => (
                <div className="col-md-6 " key={index}>
                  <div className="service-grid-card ">
                    <div className="service-grid-card-head">
                      <span className="s-text-3">{service.title}</span>
                    </div>
                    <div className="service-grid-card-body">
                      <p className="p-text-9">{service.description}</p>
                    </div>
                    <div className="service-grid-card-foot">
                      <img
                        src={service.imgSrc}
                        width={120}
                        height={120}
                        className="service-img"
                        alt={`${service.title}-img`}
                      />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
        <section className="home-section-3">
          <div className="signup-div">
            <span className="s-text-6">Trade Anytime, Anywhere</span>
            <div className="Trade">
              <div className="signup-div-body">
                <p className="p-text-7">
                  The Coindh app and website allow you to trade crypto with ease.
                </p>
                <div className="signup-div-foot">
                  <button className="download-btn">
                    Download App
                    <FiArrowRight />
                  </button>
                  <div className="div-download-icon">
                    <img
                      width={24}
                      height={24}
                      src={appstoreIcon}
                      alt="appstore"
                      className="download-icon"
                      onClick={() => window.open(Config.appLinks.appStore)}
                    />
                    {/* <img
                      src={apkIcon}
                      width={24}
                      height={24}
                      alt="apk"
                      className="download-icon"
                    /> */}
                    <img
                      src={playstoreIcon}
                      width={24}
                      height={24}
                      alt="playstore"
                      className="download-icon"
                      onClick={() => window.open(Config.appLinks.googlePlay)}
                    />
                  </div>
                </div>
              </div>
              <div>
                <img src={"https://image-charts.com/chart?cht=qr&chs=150x150&chl=" + Config.FRONEND_URL+"/download/app&choe=UTF-8&chld=L"} alt="download-app"/>
                {/* <img src={Qr}/> */}
              </div>
            </div>
          </div>
        </section>
        <section className="home-section-2">
          <h2 className="h-text-2">Coindh by Your Side</h2>

          <div className="customer-service-grid">
            <div className="row g-5">
              <div className="col-lg-6 col-md-12 ">
                <div className="customer-card">
                  <div className="customer-card-head">
                    <span className="s-text-3">Customer Service</span>
                  </div>
                  <div className="customer-card-body">
                    <p className="p-text-9">
                      Your questions, answered. Contact Coin DH customer support
                      with your questions at any time.
                    </p>
                  </div>
                  <div className="customer-card-foot">
                    <p className="p-help mt-5">
                      {siteSettings && siteSettings.supportEmail ? <li className="footer-li"> <a className="foot-link" href={"mailto:" + siteSettings.supportEmail}>Coindh help center</a> :  {siteSettings.supportEmail} </li> :<></>}</p>
                  </div>
                </div>
              </div>
              <div className=" col-lg-6 col-md-12 ">
                <div className="customer-card">
                  <div className="customer-card-head">
                    <span className="s-text-3">Join Our Community</span>
                  </div>
                  <div className="customer-card-body">
                    <p className="p-text-9">
                      Your questions, answered. Contact Coin DH customer support
                      with your questions at any time.
                    </p>
                  </div>
                  <div className="customer-card-foot">
                    <div className="customer-card-foot-body">
                      {/* <p className="p-help">English Community</p> */}
                      <div className="customer-card-foot-link">
                      {siteSettings && siteSettings.whatsappLink ? (
                        <a href={siteSettings.whatsappLink} className="social-link">
                          <FaWhatsapp
                            alt="whatsapp"
                            className="text-success"
                            size={20}
                          />
                        </a>):""}
                        {siteSettings && siteSettings.twitterLink ? (
                        <a href={siteSettings.twitterLink} className="social-link">
                          <img
                            src={telegram}
                            width={32}
                            height={32}
                            alt="telegram"
                            className="social-link-img"
                          />
                        </a>):""}
                        {siteSettings && siteSettings.instagramLink ? (
                        <a href={siteSettings.instagramLink} className="social-link">
                          <FaInstagram
                            alt="instagram"
                            className="insta"
                            size={20}
                          />
                        </a>):""}
                      </div>
                    </div>
                    {/* <p className="p-help">View all 20+ languages</p> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="home-section-2">
          <h2 className="h-text-2">FAQ’s</h2>

          <div className="accordion" id="accordionExample">
            {accordionData.map((item, index) => (
              <div className="accordion-item" key={index}>
                <h2 className="accordion-header">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target={`#${item.id}`}
                    aria-expanded="false"
                    aria-controls={item.id}
                  >
                    {item.question}
                  </button>
                </h2>
                <div
                  id={item.id}
                  className="accordion-collapse collapse"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <p className="accordion-body-text">{item.answer}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>
      </div>
      <Footer />
    </div>
  );
}
